<div class="ols-form">
  <div class="ols-form-wrapper">
    <div class="ols-form-group"
      [ngClass]='{ "has-focus": decimalFocus, "has-success": validDecimal(), "has-error": !validDecimal() && decimalHadFocus, "is-empty": isDecimalLeeg() }'>
      <div class="ols-label">
        <div class="ols-label-leading"></div>
        <label for="decimal">{{labelDecimal}}</label>
      </div>
      <input #decimalField [disabled]="!isCurrentVraag" [required]="decimalRequired" type="text" name="decimal" placeholder="{{placeholder}}"
        [(ngModel)]="getal" (focus)='setdecimalFocus(true)' (blur)='setdecimalFocus(false)'
        (keypress)='isDecimalKey($event)'>
      <p class="error-block" *ngIf="!validDecimal() && !isDecimalLeeg() && decimalHadFocus">{{errormessageDecimal}}</p>
      <p class="error-block" *ngIf="isDecimalLeeg() && decimalHadFocus">Dit veld is verplicht</p>
    </div>
  </div>
</div>